'use strict';

(function (angular) {
    customAutofocus.$inject = ['$timeout'];
    angular
        .module('jwsdw.storeFinder')
        .directive('customAutofocus', customAutofocus);


    /**
     * @description Set autofocus directive
     * @param {Function} $timeout the angularjs setTimeout abstraction
     * @returns {{link: link, restrict: string}} directive
     */
    function customAutofocus($timeout) {
        return {
            'restrict': 'A',
            'link': function(scope, element) {
                if (window.jwsdwStorefinderSettings.autofocus) {
                    $timeout(function() {
                        element[0].focus();
                    }, 0);
                }
            }
        };
    }
}(angular));